module.exports = __webpack_public_path__ + "media/images/my_apps/for_organizations_2017_app_icon_rounded_115-2ac849281ebb96fd55eca5ff98d8ded5.png";